// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const ShippingAddress = require('components/commons/shippingAddress/shippingAddress');

class HireCreditCardStep4 extends React.Component {
   
    render() {
        const {
            immHireContactData,
            immShippingAddressList,
            setShippingAddress,
        } = this.props;
        const isShippingAddressFetching = immShippingAddressList.get('shippingAddressList');
        let shippingAddressBlock = <LoadingSection />;

        if (!!isShippingAddressFetching) {
            shippingAddressBlock = (
                <ShippingAddress
                    immShippingAddressList={immShippingAddressList}
                    setShippingAddress={setShippingAddress}
                    immHireContactData={immHireContactData}
                />
            );
        }

        return (
            <article className="row hire-card-neruda-step-four">
                <div className="col-sm-12">
                    {shippingAddressBlock}
                </div>
            </article>
        );
    }
}

HireCreditCardStep4.propTypes = {
    immHireContactData: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object.isRequired,
    setShippingAddress: PropTypes.func.isRequired,
};

module.exports = HireCreditCardStep4;
